module.exports = __webpack_public_path__ + "img/mail.d0f4ff4e.svg";